<template>
  <div class="content">
    <!-- 轮播图 -->
    <el-carousel height="4.4rem" :interval="4000">
      <el-carousel-item
        v-for="(item, index) in arr"
        :key="index"
        :class="'index' + index"
      >
        <div class="container">
          <div class="left">
            <img :src="item.img" />
          </div>
          <div class="right">
            <div>
              <h2 v-show="item.text.title">{{ item.text.title }}</h2>
              <h3
                style="max-width: 424px"
                v-for="(iten, inde) in item.text.context"
                :key="inde + 'a'"
              >
                {{ iten }}
              </h3>
            </div>
          </div>
        </div>
      </el-carousel-item>
    </el-carousel>
    <div class="desc">
      <p>
        辽宁云信信息技术有限公司成立于2017年，从成立至今，我们始终致力于打造全方位的专业文印服务团队，专注于公安、检察院、法院等领域。
      </p>

      <p>
        “快速响应、专业服务”是我公司一贯的服务理念，经过多年的不懈努力与发展，现已在全省范围内承接了100多家客户的文印服务工作。
      </p>

      <p>
        未来，我们将继续以卓越的服务品质、专业的技术实力，为不同群体的客户提供更为高效、安全、优质的文印服务，使我们的客户，在享受到信息科技发展带来的最新成果的同时，能够持续不断的获得最大限度的收益。
      </p>
    </div>
  </div>
</template>

<script>
import { useStore } from 'vuex'
import { computed } from 'vue'
import banner1 from '../assets/banner1.png'
import banner2 from '../assets/banner2.png'
export default {
  name: 'Home',
  components: {
    // Function,
  },
  setup() {
    const arr = [
      {
        img: banner1,
        text: {
          context: [
            ' 辽宁云信信息技术有限公司成立于2017年，从成立至今，我们始终致力于打造全方位的专业文印服务团队，专注于公安、检察院、法院等领域。 ',
          ],
        },
      },
      {
        img: banner2,
        text: {
          context: [
            ' “快速响应、专业服务”是我公司一贯的服务理念，经过多年的不懈努力与发展，现已在全省范围内承接了100多家客户的文印服务工作。 ',
          ],
        },
      },
      {
        img: banner2,
        text: {
          context: [
            ' 未来，我们将继续以卓越的服务品质、专业的技术实力，为不同群体的客户提供更为高效、安全、优质的文印服务，使我们的客户，在享受到信息科技发展带来的最新成果的同时，能够持续不断的获得最大限度的收益。  ',
          ],
        },
      },
    ]
    const fnData = [
      {
        img: 'http://filseclab.com/images/ico_shield.png',
        title: ['杀病毒/木马', '抵御各类威胁'],
        desc: undefined,
      },
      {
        img: 'http://filseclab.com/images/ico_cloud.png',
        title: ['智能主动防御', 'EVANET云安全'],
        desc: undefined,
      },
      {
        img: 'http://filseclab.com/images/ico_blackbox.png',
        title: ['智能黑盒', '超级回滚'],
        desc: undefined,
      },
      {
        img: 'http://filseclab.com/images/ico_isolate.png',
        title: ['威胁虚拟机', '智能高级启发'],
        desc: undefined,
      },
      {
        img: 'http://filseclab.com/images/ico_lock.png',
        title: ['威胁诱捕陷阱', '隐私数据保护'],
        desc: undefined,
      },
      {
        img: 'http://filseclab.com/images/ico_bsod.png',
        title: ['系统加固', '蓝屏灾难保护'],
        desc: undefined,
      },
      {
        img: 'http://filseclab.com/images/ico_smart.png',
        title: ['智能提速', '资源载荷均衡'],
        desc: undefined,
      },
      {
        img: 'http://filseclab.com/images/ico_speech.png',
        title: ['语音控制与合成', '能听会说智能交互'],
        desc: undefined,
      },
    ]
    const newsList = [
      {
        title: '费尔为XP用户保驾护航 ',
        url: 'http://filseclab.com/zh-cn/news/14040115.htm',
      },
      {
        title: '费尔智能杀毒 8.17 发布',
        url: 'http://filseclab.com/zh-cn/news/13071016.htm',
      },
      {
        title: '费尔受邀出席AVAR2012国际盛会',
        url: 'http://filseclab.com/zh-cn/news/12112818.htm',
      },
      {
        title: '宣传片：V8来了',
        url: 'http://filseclab.com/zh-cn/news/12092908.htm',
      },
      {
        title: '费尔智能杀毒V8震撼公测',
        url: 'http://filseclab.com/zh-cn/news/12080808.htm',
      },
      {
        title: '世界权威机构VB100公布全球杀软评测报告: 费尔杀毒侦测率99.98%',
        url: 'http://filseclab.com/zh-cn/news/12011113.htm',
      },
    ]
    const updateLog = [
      {
        title:
          '2021/07/02 07:14 (1). 病毒库升级到2021.07.02.07:14，新增539个威胁特征。本日第1次更新，日累计新增539。总数：10147187',
      },
    ]
    const state = computed(() => useStore().state.client)
    return {
      arr,
      fnData,
      newsList,
      updateLog,
      state,
    }
  },
}
</script>

<style lang="scss" scoped>
.index0 {
  background-image: linear-gradient(#2883b0, #2b7cba, #0379ac);
}
.index1 {
  background-image: linear-gradient(#6641b6, #9c3cc5, #b82eda);
}
.index2 {
  background-image: linear-gradient(to left bottom, #d57031, #de7a4b, #eba04a);
}
.content {
  min-height: calc(100vh - 148px);
}
.container {
  display: flex;
  align-items: center;
  justify-content: space-around;
  width: 12rem;
  height: 100%;
  margin: auto;
  font-size: 0;

  .left {
    img {
      height: 3.6rem;
    }
  }
  .right {
    display: flex;
    justify-content: space-around;
    flex-direction: column;
    height: 80%;
    .littleImg {
      width: 2.51rem;
    }
  }
  h2,
  h3 {
    color: #fff;
  }
  h2 {
    font-size: 0.32rem;
    color: #2a81b7;
  }
  h3 {
    font-size: 0.22rem;
  }
}
.el-carousel {
  margin-bottom: 0.8rem;
}
.desc {
  font-size: 20px;
  color: #666;
  text-indent: 48px;
  width: 12rem;
  margin: 0 auto 60px;
  line-height: 36px;
  font-weight: normal;
}
</style>
